import React from "react";
import ReactDOM from "react-dom";
import "./asssets/css/index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import ErrorBoundary from "./utils/ErrorBoundary";
import "jquery";
import "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
